module.exports = __webpack_public_path__ + "assets/pingguo.26275c3a.svg";